// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"R8-z"};